import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Icon from '@material-ui/core/Icon';
import AddCircle from '@material-ui/icons/AddCircle';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import VerifiedUser from '@material-ui/icons/VerifiedUser';
import Star from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';
import CircularProgress from '@material-ui/core/CircularProgress';
import Chip from '@material-ui/core/Chip';
import { Typography } from '@material-ui/core';
import { LayoutContext } from "App/Layout/store";
import { GetCertificados, EliminaCertificado, VerificaCertificado, EstableceRemitenteDefecto } from 'App/Administracion/Actions';
import {CertificadosContext} from "App/Administracion/Certificados/store";
import CargarCertificado from './CargarCertificado';
import moment from 'moment';

const styles = theme => ({
    root: {
      width: '100%',
      marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
    },
    table: {
      minWidth: 700,
    },
    textAlignRight: {
        textAlign: "right"
    },
    iconHover: {
        '&:hover': {
            color: "rgb(61,30,144)",
            cursor: "pointer"
        }
    }
});

function Certificados(props) {
    const { classes, theme } = props;
    const certificadosContext = useContext(CertificadosContext);
    const layoutContext = useContext(LayoutContext);

    const [ certificados, setCertificados ] = useState([]);
    const [ verificandoId, setVerificandoId ] = useState(null);

    var getCerts = ()=>GetCertificados((certificados)=> {
        setCertificados(certificados);
    })
    
    useEffect(()=> {
        getCerts()
    }, []);

    const handleVerificar = (certificado) => {
        setVerificandoId(certificado.IdRemitente);
        VerificaCertificado(certificado.IdRemitente, (res) => {
            setVerificandoId(null);
            if (res && res.Valido) {
                layoutContext.dispatch({
                    type: "setAlert", Alert: {
                        sinAccion: true,
                        titulo: "✅ Certificado Autorizado en el SII",
                        contenido: (
                            <div>
                                <p><strong>Titular:</strong> {res.RutTitular} ({res.NombreTitular})</p>
                                <p><strong>Empresa:</strong> {res.Empresa} ({res.RutEmpresa})</p>
                                <p><strong>Vencimiento:</strong> {moment(res.Vencimiento).format("L")}</p>
                                <p style={{ color: "green", fontWeight: "bold" }}>{res.Mensaje}</p>
                            </div>
                        )
                    }
                });
            } else {
                layoutContext.dispatch({
                    type: "setAlert", Alert: {
                        sinAccion: true,
                        titulo: "⚠️ Certificado No Autorizado en el SII",
                        contenido: (
                            <div>
                                <p style={{ color: "red", fontWeight: "bold" }}>{res?.Mensaje || "No fue posible validar la autorización del certificado ante el SII."}</p>
                                <p>Para solucionarlo:</p>
                                <ol>
                                    <li>Ingrese a <strong>sii.cl</strong> con la clave del contribuyente o representante legal.</li>
                                    <li>Vaya a <strong>Factura Electrónica &gt; Actualización y mantención de datos de la empresa &gt; Mantención de usuarios autorizados</strong>.</li>
                                    <li>Agregue el RUT del titular (<strong>{res?.RutTitular || certificado.Rut + "-" + certificado.Dv}</strong>) y marque el permiso <strong>"Firmar Doctos."</strong>.</li>
                                </ol>
                            </div>
                        )
                    }
                });
            }
        }, (err) => {
            setVerificandoId(null);
            console.error("Error al verificar certificado:", err);
            /*layoutContext.dispatch({
                type: "setAlert", Alert: {
                    sinAccion: true,
                    titulo: "Error de Conexión",
                    contenido: "Ocurrió un error al intentar verificar el certificado contra el SII."
                }
            });*/
        });
    };

    return (
        <div>
            <CargarCertificado getCerts = {getCerts}/>
            <Grid container spacing={24}>
                <Grid item sm={12}>
                    <Typography variant="h5">Certificados para el SII</Typography>
                </Grid>
                <Grid item sm={12} className={classes.textAlignRight}>
                    <Tooltip title="Agregar certificado">
                        <Icon color="primary" aria-label="Add" className={classes.iconHover} onClick={(evt) => {
                            evt.preventDefault();
                            certificadosContext.dispatch({ type: "toggleCargarCertificado" });
                        }}>
                            <AddCircle />
                        </Icon>
                    </Tooltip>
                </Grid>
                <Grid item sm={12}>
                    <Paper className={classes.root}>
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Acciones</TableCell>
                                    <TableCell>Rut</TableCell>
                                    <TableCell>Nombre</TableCell>
                                    <TableCell>Vencimiento</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(certificados || []).map((certificado, ix) => {
                                    return (
                                    <TableRow key={ix}>
                                        <TableCell>
                                                <Tooltip title={certificado.EsDefecto ? "Certificado por defecto para emitir y firmar" : "Establecer como certificado por defecto"}>
                                                    <Icon
                                                        color={certificado.EsDefecto ? "primary" : "action"}
                                                        className={classes.iconHover}
                                                        style={{ marginRight: 10, verticalAlign: 'middle', cursor: "pointer" }}
                                                        onClick={(evt) => {
                                                            evt.preventDefault();
                                                            if (!certificado.EsDefecto) {
                                                                EstableceRemitenteDefecto(certificado.IdRemitente, getCerts);
                                                            }
                                                        }}
                                                    >
                                                        {certificado.EsDefecto ? <Star /> : <StarBorder />}
                                                    </Icon>
                                                </Tooltip>
                                                <Tooltip title="Verificar autorización en el SII">
                                                    {verificandoId === certificado.IdRemitente ? (
                                                        <CircularProgress size={20} style={{ marginRight: 10, verticalAlign: 'middle' }} />
                                                    ) : (
                                                        <Icon color="primary" className={classes.iconHover} style={{ marginRight: 10, verticalAlign: 'middle' }} onClick={(evt) => {
                                                            evt.preventDefault();
                                                            handleVerificar(certificado);
                                                        }}>
                                                            <VerifiedUser />
                                                        </Icon>
                                                    )}
                                                </Tooltip>
                                                <Tooltip title="Eliminar certificado">
                                                    <Icon color="error" className={classes.iconHover} style={{ verticalAlign: 'middle' }} onClick={(evt) => {
                                                        evt.preventDefault();
                                                        layoutContext.dispatch({
                                                            type: "setAlert", Alert: {
                                                                Accion: () => EliminaCertificado(certificado.IdRemitente,getCerts),
                                                                titulo: "¿Está seguro?",
                                                                contenido: "¿Está seguro que desea eliminar este certificado? Esta acción es irreversible."
                                                            }
                                                        })
                                                    }}>
                                                        <RemoveCircle />
                                                    </Icon>
                                                </Tooltip>
                                            </TableCell>
                                        <TableCell component="th" scope="row">
                                            {certificado.Rut}-{certificado.Dv}
                                            {certificado.EsDefecto && (
                                                <Chip
                                                    size="small"
                                                    label="Por defecto"
                                                    color="primary"
                                                    style={{ marginLeft: 8, height: 22, fontSize: '0.75rem' }}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell>{certificado.Nombre}</TableCell>
                                        <TableCell>{moment(certificado.Vencimiento).format("L")}</TableCell>
                                    </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </Paper>
                </Grid>
            </Grid>
        </div>
        )
}

Certificados.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Certificados);